import {
  GET_CHANCE_GAMES_LIST_REQUEST,
  GET_CHANCE_GAMES_LIST_SUCCESS,
  GET_CHANCE_GAMES_LIST_FAILURE
} from 'Store/constants';

const initialState = {
  list: {
    data: {},
    isLoading: false,
    error: null,
  },
  drawDates: {
    data: {},
    isLoading: false,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CHANCE_GAMES_LIST_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
          error: null
        }
      };
    case GET_CHANCE_GAMES_LIST_SUCCESS:
      return {
        ...state,
        list: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };
    case GET_CHANCE_GAMES_LIST_FAILURE:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload
        }
      };
    
    default:
      return state;
  }
};
